import { useEffect, useRef } from 'react'
import { io } from 'socket.io-client'

/** useProgrammeSocket — real-time updates zodra admin de agenda wijzigt. */
export function useProgrammeSocket(onChange) {
  const cbRef = useRef(onChange)
  useEffect(() => { cbRef.current = onChange }, [onChange])

  useEffect(() => {
    const token = localStorage.getItem('auth_token')
    if (!token) return
    const s = io({
      auth: { token },
      transports: ['polling', 'websocket'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
    })
    const subscribe = () => s.emit('programme:subscribe')
    s.on('connect', subscribe)
    s.on('reconnect', subscribe)
    s.on('programme:changed', (p) => {
      try { cbRef.current?.(p) } catch (e) { console.error('programme:changed handler', e) }
    })
    return () => {
      try { s.emit('programme:unsubscribe') } catch {}
      s.removeAllListeners()
      s.disconnect()
    }
  }, [])
}
